import React from "react";
import { useTranslation } from "react-i18next";

export default function About() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col bg-white h-svh-w-fallback max-md:pt-10 max-md:px-6">
      <p className="text-black font-bold text-lg">{t("about.title")}</p>
      <p className="text-black">{t("about.last_updated")}</p>
      <p className="text-black">{t("about.p1")}</p>
      <p className="text-black">{t("about.p2")}</p>
      <a
        href="https://twitter.com/dockethealthapp"
        target="_black"
        className="underline text-blue-600 hover:text-blue-800"
      >
        {t("about.social")}
      </a>
    </div>
  );
}
